import { Component, OnInit, ElementRef, forwardRef, ViewEncapsulation, Renderer, Injector } from '@angular/core';
import { FormGroup, FormBuilder, NG_VALUE_ACCESSOR, FormControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import { BaseFormControl, UploaderSettings, UploadEntity, BaseAbstractControl, mohValidators, DataService, FormSubmitService } from 'moh-package';
import { UtilitiesService } from '../../../services/general/utilities.service';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'moh-worsening-advocate',
  templateUrl: './worsening-advocate.component.html',
  styleUrls: ['./worsening-advocate.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => WorseningAdvocateComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => WorseningAdvocateComponent) }]
})
export class WorseningAdvocateComponent extends BaseAbstractControl implements OnInit {

  powerOfAttorneySettings: UploaderSettings = new UploaderSettings();

  advocateTypes: Observable<any>;

  cityValidators: ValidatorFn[] = [];
  streetValidators: ValidatorFn[] = [];
  houseNumberValidators: ValidatorFn[] = [];
  entranceValidators: ValidatorFn[] = [];
  appartmentValidators: ValidatorFn[] = [];
  zipCodeValidators: ValidatorFn[] = [];
  postboxValidators: ValidatorFn[] = [];

  constructor(injector: Injector, private fb: FormBuilder, renderer: Renderer,  el: ElementRef, private dataService: DataService, formSubmitService: FormSubmitService, private utilitiesService: UtilitiesService) {

    super(injector);

  }

 ngOnInit() {

    this.baseAbstractControl = new FormGroup({
      LastName: new FormControl('', [mohValidators.required(), mohValidators.minLength(2, "הערך בשדה שם משפחה קצר מידי יש להזין לפחות 2 תווים"), mohValidators.maxLength(25, "הערך בשדה שם משפחה ארוך מידי ניתן להזין עד 25 תווים"), mohValidators.pattern(new RegExp("^[{א-ת} \"']*$"), "יש להזין אותיות בעברית בלבד")]),
      FirstName: new FormControl('', [mohValidators.required(), mohValidators.minLength(2, "הערך בשדה שם פרטי קצר מידי יש להזין לפחות 2 תווים"), mohValidators.maxLength(25, "הערך בשדה שם פרטי ארוך מידי ניתן להזין עד 25 תווים"), mohValidators.pattern(new RegExp("^[{א-ת} \"']*$"), "יש להזין אותיות בעברית בלבד")]),
      AdvocateType: new FormControl('', [mohValidators.required()]),
      LicenseNumber: new FormControl('', [mohValidators.required(), mohValidators.maxLength(50)]),
      HPNumber: new FormControl('', [mohValidators.required(), mohValidators.maxLength(50), mohValidators.pattern("[5][0-9]{8}", "יש להזין מספר ח.פ. / ע.ר. בן 9 ספרות. ח.פ מתחיל בספרה 5 .יש להזין ספרות בלבד")]),
      PhoneNumber: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      FaxNumber: new FormControl('', []),
      Email: new FormControl('', [mohValidators.required(), mohValidators.maxLength(50), mohValidators.email('יש להזין כתובת תקנית באותיות לועזיות וללא רווחים')]),
      PostAddress: new FormControl('', []),
      PowerOfAttorneyFile: new FormControl('', [mohValidators.required()]),
    });

    this.cityValidators = [mohValidators.required()];
    this.streetValidators = [mohValidators.required(), this.utilitiesService.streetPattern(new RegExp("^[{א-ת} 0-9\"']*$"), "יש להזין ספרות ואותיות עבריות בלבד")];
    this.houseNumberValidators = [mohValidators.required(), mohValidators.maxLength(5), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה מספר בית יש להזין ערך מספרי שלם בלבד")];
    this.appartmentValidators = [mohValidators.maxLength(5), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה מספר דירה יש להזין ערך מספרי שלם בלבד")];
    this.zipCodeValidators = [mohValidators.required(), mohValidators.minLength(5), mohValidators.maxLength(7), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה מיקוד יש להזין ערך מספרי שלם בלבד")];
    this.postboxValidators = [ mohValidators.maxLength(5), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה ת.ד. יש להזין ערך מספרי שלם בלבד")]
   
    this.initializePowerOfAttorneySettings();

    this.getAdvocateTypes();

    super.ngOnInit();
  }

  initializePowerOfAttorneySettings() {

    this.powerOfAttorneySettings = {

      allowMimeTypes: ['application/pdf', 'image/bmp', 'image/gif', 'image/tiff', 'image/jpeg', 'image/png'],
      maxFileSize: 10 * 1024 * 1024, //10MB
      queueLimit: 1,
      queueMinLimit: 1,
      isMultiple: false,
      hasDescription: false,
      isDescriptionRequired: false,
      isRequired: true,
      isSigned: false
    };
  }

  getAdvocateTypes() {

    this.advocateTypes = this.dataService.getList("MOH.Gazzezet.AdvocateType");
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/worsening/worsening-advocate/worsening-advocate.component.ts